import { MainLayout } from "layouts";
import { DataTable } from "components/DataTable";

import { useRecepiesPage } from "./hooks";
import { columns } from "./helpers";
import { TextInput } from "components/TextInput";

export const PagesPage = () => {
  const {
    data,
    pagination,
    search,
    onRowClick,
    onNextClick,
    onPreviousClick,
    onTableHeaderClick,
    onSearchChanged,
  } = useRecepiesPage();

  return (
    <MainLayout title="Pages">
      <TextInput
        containerClassName="max-w-sm mb-5"
        type="text"
        name="search"
        placeholder="Search"
        value={search.search}
        onChage={onSearchChanged}
      />
      <DataTable
        columns={columns(onTableHeaderClick)}
        data={data}
        onRowClick={onRowClick}
        pagination={pagination}
        nextClick={onNextClick}
        previousClick={onPreviousClick}
      />
    </MainLayout>
  );
};
